import { getRoutines, getRoutinesByActivity } from "../api";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";




export default function Routines({routines, setRoutines, setFromActivities, fromActivities, setActivityId, activityId}) {

    const [singleUserRoutines, setSingleUserRoutines] = useState(false)
    const [singleUserId, setSingleUserId] = useState('')
    const navigate = useNavigate();

    const fetchRoutines = async () => {
        try {
            if (activityId) {
                const result = await getRoutinesByActivity(activityId)
                setRoutines(result);
            } else {
                const result = await getRoutines();
                setRoutines(result);
            }
        } catch (err) {
            console.error("Failed to fetch routines", err);
        }        
    };

    useEffect(() => {
        fetchRoutines();
    }, [routines]);


    return (
        <>
            <div className="routineDiv">
            {singleUserRoutines ? <button type="button" className="createButton" onClick={((event) => {
                            event.preventDefault();
                            setSingleUserRoutines(false);
                            setSingleUserId('');
                        })}>Back to all routines</button> : null }
            {activityId && !fromActivities ? <button type="button" className="createButton" onClick={((event) => {
                            event.preventDefault();
                            setActivityId('');
                        })}>Back to all routines</button> : null }
            {activityId && fromActivities ? <button type="button" className="createButton" onClick={((event) => {
                            event.preventDefault();
                            setActivityId('');
                            setFromActivities(false);
                            navigate('../activities');
                        })}>Back to all activities</button> : null }            
            { singleUserRoutines ? 
            routines.map((routine) => { return singleUserId == routine.creatorId ?
                     <div key={routine.id} className="routine">
                        <div className="routineName" >Name: {routine.name}</div>
                        <div >Creator: {routine.creatorName}</div>
                        <div>Goal: {routine.goal}</div>
                        {
                            routine.activities.map((activity) => {
                                return <div key={activity.id} className='routineActivities'> 
                                    <div> Activity Name: {activity.name} </div>
                                    <div> Desription: {activity.description} </div>
                                    { activity.duration ? <div> Duration: {activity.duration} </div> 
                                    : null }
                                    { activity.count ? <div> Count: {activity.count} </div>
                                    : null }
                                </div>
                                
                            })
                        }
                    </div> 
                    : null
                }) :
                routines.map((routine) => {
                    return <div key={routine.id} className="routine">
                        <div className="routineName" >Name: {routine.name}</div>
                        <div className="routineUsername" onClick={((event) => {
                            event.preventDefault;
                            setSingleUserRoutines(true);
                            setSingleUserId(routine.creatorId);
                            console.log('clicked')
                        })}>Creator: {routine.creatorName}</div>
                        <div>Goal: {routine.goal}</div>
                        {
                            routine.activities.map((activity) => {
                                return <div key={activity.id} className='routineActivities'> 
                                    <div className="routineUsername" onClick={((event) => {
                                        event.preventDefault;
                                        setActivityId(activity.id);
                                        console.log('clicked')
                                        })}> Activity Name: {activity.name} </div>
                                    <div> Desription: {activity.description} </div>
                                    { activity.duration ? <div> Duration: {activity.duration} </div> 
                                    : null }
                                    { activity.count ? <div> Count: {activity.count} </div>
                                    : null }
                                </div>
                                
                            })
                        }
                    </div>
                })
            }
            </div>
        </>
    )
};
